module.exports = __webpack_public_path__ + "media/react/marketing/sections/faq/assets/bubble_text_icon-e45fde59e2005ef6a0462744237772b8.svg";